import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { SendMessagePage as SendMessagePageContent } from '@/features/messages/send-message-page';

function SendMessagePage() {
  return (
    <RequireService service="MESSAGE_SEND">
      <SendMessagePageContent />
    </RequireService>
  );
}

export const Route = createFileRoute('/_app/send-message')({ component: SendMessagePage });
